import { render, staticRenderFns } from "./IconLabel.vue?vue&type=template&id=e86ae15a&"
import script from "./IconLabel.vue?vue&type=script&lang=js&"
export * from "./IconLabel.vue?vue&type=script&lang=js&"
import style0 from "./IconLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e86ae15a')) {
      api.createRecord('e86ae15a', component.options)
    } else {
      api.reload('e86ae15a', component.options)
    }
    module.hot.accept("./IconLabel.vue?vue&type=template&id=e86ae15a&", function () {
      api.rerender('e86ae15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/IconLabel.vue"
export default component.exports